var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColoredSmileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27.758,
    style: {
      fill: "#f9bf44"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,45.165a12.581,12.581,0,0,1-11.368-7.079,1,1,0,1,1,1.795-.882,10.667,10.667,0,0,0,19.146,0,1,1,0,1,1,1.795.882A12.581,12.581,0,0,1,32,45.165Z",
    style: {
      fill: "#382a12"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.003,
    cy: 29.745,
    rx: 2.5,
    ry: 2.87,
    style: {
      fill: "#382a12"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.997,
    cy: 29.745,
    rx: 2.5,
    ry: 2.87,
    style: {
      fill: "#382a12"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredSmileIcon);
export default __webpack_public_path__ + "static/media/colored_smile_icon.4c0e0cca59aa7a953c788d5a67281385.svg";
export { ForwardRef as ReactComponent };